import { Button, Divider, Modal, Space, Tag, Typography } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

interface CallModalProps {
    open: boolean;
    onClose: () => void;
}

const DAYS_BOULANGER = ['Lundi', 'Mardi', 'Jeudi'];
const DAYS_MEJANI = ['Mercredi', 'Vendredi'];

const MATERNITY_END = new Date(2026, 4, 19);

const today = new Date().toLocaleDateString('fr-BE', { weekday: 'long' });
const todayCapitalized = today.charAt(0).toUpperCase() + today.slice(1);

const isMaternityLeave = new Date() < MATERNITY_END;

export default function CallModal({ open, onClose }: CallModalProps) {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            title="Contacter un médecin"
            centered
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8 }}>
                <div>
                    <Title level={5} style={{ marginBottom: 4 }}>Dr Elisabeth Boulanger</Title>
                    <Text type="secondary">Médecine Générale</Text>
                    <br />
                    {isMaternityLeave ? (
                        <Text type="warning" style={{ display: 'block', marginTop: 6 }}>
                            En congé de maternité jusqu'au 19 mai
                        </Text>
                    ) : (
                        <>
                            <div style={{ marginTop: 6, marginBottom: 10 }}>
                                {DAYS_BOULANGER.map(day => (
                                    <Tag key={day} color={day === todayCapitalized ? 'blue' : 'default'}>{day}</Tag>
                                ))}
                            </div>
                            <Button
                                type="primary"
                                icon={<PhoneOutlined />}
                                href="tel:+32492666667"
                                onClick={onClose}
                            >
                                +32 492 66 66 67
                            </Button>
                        </>
                    )}
                </div>

                <Divider style={{ margin: 0 }} />

                <div>
                    <Title level={5} style={{ marginBottom: 4 }}>Dr Sarah Mejani</Title>
                    <Text type="secondary">Médecine Générale, diplômée en nutrition</Text>
                    <br />
                    <div style={{ marginTop: 6, marginBottom: 10 }}>
                        {DAYS_MEJANI.map(day => (
                            <Tag key={day} color={day === todayCapitalized ? 'blue' : 'default'}>{day}</Tag>
                        ))}
                    </div>
                    <Space size="small">
                        <Button
                            icon={<PhoneOutlined />}
                            href="tel:+32470500890"
                            onClick={onClose}
                        >
                            +32 470 50 08 90
                        </Button>
                        <span>
                            ou via la plateforme <a href="https://rosa.be/fr/hp/sarah-mejani/" target="_blank" rel="noopener noreferrer">Rosa</a>.
                        </span>
                    </Space>
                </div>
            </div>
        </Modal>
    );
}
